"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _uiLibrary = require("@printdeal/ui-library");
var _TogglePasswordButton = _interopRequireDefault(require("../TogglePasswordButton"));
var _loginAdapter = _interopRequireDefault(require("../../adapters/loginAdapter"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var messages = (0, _reactIntl.defineMessages)({
  email: {
    id: 'account.login.form.label.email',
    defaultMessage: 'Email'
  },
  password: {
    id: 'account.login.form.label.password',
    defaultMessage: 'Password'
  }
});
var Login = function Login(_ref) {
  var callback = _ref.callback,
    endpoint = _ref.endpoint,
    portalId = _ref.portalId,
    authToken = _ref.authToken,
    cartId = _ref.cartId,
    store = _ref.store,
    isLoading = _ref.isLoading,
    eventLabel = _ref.eventLabel;
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    password = _useState4[0],
    setPassword = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showPassword = _useState6[0],
    setShowPassword = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    elementLoading = _useState10[0],
    setElementLoading = _useState10[1];
  var _useState11 = (0, _react.useState)({
      email: false,
      password: false
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    isAutoFilled = _useState12[0],
    setIsAutoFilled = _useState12[1];
  var intl = (0, _reactIntl.useIntl)();
  (0, _react.useEffect)(function () {
    setElementLoading(loading || isLoading);
  }, [loading, isLoading]);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    setShowPassword(false);
    setLoading(true);
    (0, _loginAdapter["default"])(email, password, portalId, endpoint, authToken, cartId, store).then(function (result) {
      callback(null, _objectSpread({}, result.data));
      setLoading(false);
    })["catch"](function (error) {
      callback(error, null);
      setLoading(false);
    });
  };
  var handleChange = function handleChange(e) {
    if (e.target.name === 'email') {
      setEmail(e.target.value);
    } else {
      setPassword(e.target.value);
    }
    if (!e.target.value) {
      // Remove any lingering floatation caused by autofill if the value was emptied
      setIsAutoFilled(_objectSpread(_objectSpread({}, isAutoFilled), {}, _defineProperty({}, e.target.name, false)));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_uiLibrary.Root, {
    as: "form",
    onSubmit: handleSubmit,
    method: "POST",
    className: "pd-max-w-2xl pd-flex pd-flex-col pd-gap-3"
  }, /*#__PURE__*/_react["default"].createElement(_uiLibrary.TextField, {
    id: "email",
    name: "email",
    type: "email",
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Email",
      id: "account.login.form.label.email"
    }),
    placeholder: intl.formatMessage(messages.email),
    required: true,
    requiredLabel: intl.formatMessage({
      id: 'general.form.requiredLabel',
      defaultMessage: 'Required field'
    }),
    value: email,
    disabled: loading,
    onChange: handleChange,
    autoComplete: "username"
  }), /*#__PURE__*/_react["default"].createElement(_uiLibrary.TextField, {
    id: "password",
    name: "password",
    required: true,
    requiredLabel: intl.formatMessage({
      id: 'general.form.requiredLabel',
      defaultMessage: 'Required field'
    }),
    value: password,
    disabled: loading,
    type: showPassword ? 'text' : 'password',
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Password",
      id: "account.login.form.label.password"
    }),
    placeholder: intl.formatMessage(messages.password),
    onChange: handleChange,
    iconAfter: /*#__PURE__*/_react["default"].createElement(_TogglePasswordButton["default"], {
      eventCategory: "login_form",
      buttonLocation: "login_control",
      setShowPassword: setShowPassword,
      showPassword: showPassword,
      eventLabel: eventLabel
    }),
    autoComplete: "current-password"
  }), /*#__PURE__*/_react["default"].createElement(_uiLibrary.Button, {
    type: "submit",
    disabled: elementLoading,
    isLoading: elementLoading,
    "data-cy": "changeAccountDetailsSubmitButton",
    className: "pd-w-full"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Login",
    id: "account.login.form.label.button"
  })));
};
Login.defaultProps = {
  cartId: '',
  isLoading: false,
  eventLabel: undefined
};
Login.propTypes = {
  /** The callback which returns {err, response} */
  callback: _propTypes["default"].func.isRequired,
  /** The endpoint to authenticate against */
  endpoint: _propTypes["default"].string.isRequired,
  /** The ID of the portal to authenticate against */
  portalId: _propTypes["default"].number.isRequired,
  /** The (anonymous) authentication token for calling printdeal endpoints */
  authToken: _propTypes["default"].string.isRequired,
  /** The store key from the website */
  store: _propTypes["default"].string.isRequired,
  cartId: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  /** Use custom eventLabel for tracking */
  eventLabel: _propTypes["default"].string
};
var _default = exports["default"] = Login;